<template>
    <div class="pt-2">
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pl-1">
                <v-card
                    style="height: calc(100vh - 82px); overflow-y: auto"
                    class="default_card_wm elevation-0 rounded-l-0"
                >
                    <DocumentMenu
                        :MenuOptions="documentMenuOptions"
                        v-model:displayMode="windowStep"
                        @back="back()"
                        @zoom-in="isPDF ? zoomInPdf() : zoomManager.zoomIn()"
                        @reset-zoom="isPDF ? resetZoomPdf() : zoomManager.resetZoom()"
                        @zoom-out="isPDF ? zoomOutPdf() : zoomManager.zoomOut()"
                        @rotate-left="
                            documentPdfRotation = rotate('left', zoomManager, documentPdfRotation)
                        "
                        @rotate-right="
                            documentPdfRotation = rotate('right', zoomManager, documentPdfRotation)
                        "
                        @activity="windowStep = 'display-activity'"
                        @download="startDownloadFile()"
                        @upload="uploadDocumentDialog = true"
                        @delete="deleteDocumentDialog = true"
                    />
                    <!--<v-row no-gutters>
                        <v-col cols="6" class="d-flex align-left text-left">
                            <v-btn-back
                                @click.stop="back()"
                                v-if="mode !== 'GeneralLedger' && goBackHistory"
                                data-cy="document-back"
                            />
                            <template v-if="!isPDF && zoomManager && windowStep === 'display-pdf'">
                                <v-btn-icon
                                    icon="$oss-zoom-out"
                                    :disabled="zoomManager.disableZoomOut()"
                                    @click.stop="zoomManager.zoomOut()"
                                />
                                <v-btn-icon
                                    icon="$oss-focus"
                                    :disabled="zoomManager.disableResetZoom()"
                                    @click.stop="zoomManager.resetZoom()"
                                />
                                <v-btn-icon
                                    icon="$oss-zoom-in"
                                    :disabled="zoomManager.disableZoomIn()"
                                    @click.stop="zoomManager.zoomIn()"
                                />
                            </template>
                            <template v-if="isPDF && windowStep === 'display-pdf'">
                                <v-btn-icon icon="$oss-zoom-out" @click.stop="zoomOutPdf" />
                                <v-btn-icon icon="$oss-focus" @click.stop="resetZoomPdf()" />
                                <v-btn-icon icon="$oss-zoom-in" @click.stop="zoomInPdf" />
                            </template>
                        </v-col>
                        <v-col cols="6" class="pr-3 d-flex align-right justify-end">
                            <v-btn-toggle
                                v-model="windowStep"
                                rounded="xl"
                                class="mt-1"
                                density="compact"
                                divided
                                variant="outlined"
                                color="secondary"
                                mandatory
                            >
                                <v-btn :value="'table'" icon="$fa-table"> </v-btn>
                                <v-btn :value="'display-accounting-lines'" icon="$fa-list"></v-btn>
                                <v-btn
                                    :value="'display-pdf'"
                                    icon="$oss-file"
                                    :disabled="!document.signedUrl"
                                    :readonly="!document.signedUrl"
                                >
                                </v-btn>
                            </v-btn-toggle>
                            <v-menu offset-y class="pl-2">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon icon="$dots_vertical" v-bind="props" />
                                </template>
                                <v-list rounded="xl">
                                    <v-list-item
                                        v-if="isAccountingUser"
                                        :disabled="!document.signedUrl"
                                        @click="windowStep = 'display-activity'"
                                    >
                                        <v-list-item-title>Afficher l'activité</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-activity</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-divider class="mb-2" />
                                    <v-list-item
                                        @click="startDownloadFile"
                                        v-if="document.signedUrl"
                                    >
                                        <v-list-item-title
                                            >Télécharger le document</v-list-item-title
                                        >
                                        <template v-slot:append>
                                            <v-icon>$oss-download</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item @click="uploadDocumentDialog = true" v-else>
                                        <v-list-item-title>Ajouter un document</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-upload</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-divider class="mb-2" />
                                    <v-list-item
                                        @click="deleteDocumentDialog = true"
                                        :disabled="disabledDelete"
                                        color="error"
                                        :active="!disabledDelete"
                                    >
                                        <v-list-item-title>Supprimer</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-trash</v-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                    </v-row>-->
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-window v-model="windowStep">
                                <v-window-item :value="'table'">
                                    <v-data-table
                                        :headers="headers"
                                        :items="calculatedLeasing"
                                        class="table"
                                        fixed-header
                                        hide-default-footer
                                        height="90vh"
                                        :items-per-page="-1"
                                        v-if="!$vuetify.display.mobile"
                                        density="compact"
                                    >
                                        <template v-slot:item="props">
                                            <tr :class="props.item.selected ? 'info' : ''">
                                                <td class="text-left">
                                                    {{ formatDate(props.item.date) }}
                                                </td>
                                                <td class="text-left">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.netAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.vatAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.grossAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left" v-if="hasInsuranceAmount">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.insuranceNetAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left" v-if="hasInsuranceAmount">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.insuranceVatAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left" v-if="hasMaintenanceAmount">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.maintenanceNetAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left" v-if="hasMaintenanceAmount">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.maintenanceVatAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.totalAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-window-item>
                                <v-window-item :value="'display-accounting-lines'">
                                    <v-row no-gutters>
                                        <v-col
                                            cols="12"
                                            style="height: calc(100vh - 130px); overflow-y: auto"
                                        >
                                            <accounting-item-static
                                                :companyId="selectedCompany.id"
                                                :documentId="document.id"
                                                :mode="isAccountingItem ? 'AllOption' : 'Embedded'"
                                                ref="accountingItemStatic"
                                                :key="accountingLinesRefreshKey"
                                                @update="startToBeDoneIfNecessary"
                                                @upsert="onAccountingItemUpdated"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item :value="'display-activity'">
                                    <v-row no-gutters>
                                        <v-col
                                            cols="12"
                                            style="height: calc(100vh - 130px); overflow-y: auto"
                                        >
                                            <UsersActivitiesHistory :documentId="document.id">
                                            </UsersActivitiesHistory>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item :value="'display-pdf'">
                                    <v-row no-gutters>
                                        <v-col
                                            cols="12"
                                            style="height: calc(100vh - 130px); overflow-y: auto"
                                            v-if="isPDF"
                                        >
                                            <ossPdf ref="ossPdfRef" :documentId="document.id" />
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            style="height: calc(100vh - 130px); overflow-y: auto"
                                            v-else
                                        >
                                            <div
                                                style="
                                                    position: relative;
                                                    width: 100%;
                                                    height: 0;
                                                    padding: 0;
                                                    padding-bottom: 141.4516129032258%;
                                                    margin-bottom: 50px;
                                                "
                                            >
                                                <svg
                                                    id="svg-document-static"
                                                    v-if="document"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="100%"
                                                    :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                                    style="
                                                        position: absolute;
                                                        width: 100%;
                                                        left: 0;
                                                        top: 0;
                                                        background: #fff;
                                                    "
                                                >
                                                    <g>
                                                        <image
                                                            id="svg-image-document-static"
                                                            :xlink:href="document.signedUrl"
                                                            x="0"
                                                            y="0"
                                                            :height="`${imageHeight}px`"
                                                            :width="`${imageWidth}px`"
                                                        />
                                                        <template
                                                            v-for="(variant, index) in svgVariants"
                                                            :key="`coord-${document.id}-${index}`"
                                                        >
                                                            <template
                                                                v-for="(
                                                                    coord, index2
                                                                ) in variant.coordinates"
                                                                :key="`coord-${document.id}-${index}-${index2}`"
                                                            >
                                                                <polygon
                                                                    :ref="`variants-${index}-${index2}`"
                                                                    :points="getPoints(coord)"
                                                                    :style="
                                                                        variant.active
                                                                            ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                                                            : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                                    "
                                                                    @click.stop="
                                                                        variant.active
                                                                            ? ''
                                                                            : showCorrespondingField(
                                                                                  {
                                                                                      variant,
                                                                                      currentIndex:
                                                                                          index,
                                                                                      copyIndex:
                                                                                          index2,
                                                                                  },
                                                                              )
                                                                    "
                                                                    :class="
                                                                        variant.focus
                                                                            ? 'highlighted'
                                                                            : ''
                                                                    "
                                                                />
                                                            </template>
                                                        </template>
                                                    </g>
                                                </svg>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                            </v-window>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="my-0 pl-2">
                <v-card
                    style="
                        border-top-right-radius: 0px !important;
                        border-bottom-right-radius: 0px !important;
                        height: calc(100vh - 82px);
                        overflow-y: auto;
                    "
                    class="default_card_wm elevation-0 rounded-l-0"
                >
                    <v-card-text class="pt-0">
                        <v-row>
                            <v-col cols="9" />
                            <v-col cols="3" class="mt-2 d-flex align-right justify-end">
                                <v-tooltip bottom v-if="isInsideAccountingClosing">
                                    <template #activator="{ props }">
                                        <div v-bind="props">
                                            <v-btn-edit
                                                v-if="document.id"
                                                :disabled="true"
                                                @click.stop="valid()"
                                            />
                                            <v-btn-add
                                                v-else
                                                :disabled="true"
                                                @click.stop="valid()"
                                            />
                                        </div>
                                    </template>
                                    <span
                                        >Impossible d'ajouter ou modifier : la date sélectionnée se
                                        trouve dans une période comptable clôturée.</span
                                    >
                                </v-tooltip>

                                <template v-else>
                                    <v-btn-edit
                                        v-if="document.id"
                                        :disabled="!isValid"
                                        @click.stop="valid()"
                                    />
                                    <v-btn-add v-else :disabled="!isValid" @click.stop="valid()" />
                                </template>
                            </v-col>
                            <v-col cols="12">
                                <v-list class="pt-0" density="compact">
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Nom</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div>{{ leasing.title }}</div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Statut</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div
                                                        v-if="
                                                            document.errorMessage &&
                                                            reUploadDocument
                                                        "
                                                        style="color: red"
                                                    >
                                                        Erreur : {{ document.errorMessage }}
                                                    </div>
                                                    <div
                                                        v-else-if="
                                                            document && document.errorMessage
                                                        "
                                                        style="color: red"
                                                    >
                                                        Erreur de lecture du fichier : contacter
                                                        votre cabinet
                                                    </div>
                                                    <!-- <div v-else-if="document.status==='ORIGINAL_UPLOADED'">En attente d'analyse</div> -->
                                                    <!-- <div v-else-if="document.status==='UPLOADED'">En attente d'analyse</div> -->
                                                    <div
                                                        v-else-if="
                                                            !document.id &&
                                                            leasing.status === 'ANALYSED'
                                                        "
                                                    >
                                                        En cours de création
                                                    </div>
                                                    <div
                                                        v-else-if="document.status === 'VALIDATED'"
                                                    >
                                                        Créé
                                                    </div>
                                                    <div v-else>OK</div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                    <v-list-item :ripple="false" class="oss-list-item my-2">
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters class="align-center">
                                                <v-col
                                                    cols="3"
                                                    style="
                                                        border-right: 1px #ededed solid;
                                                        height: 28px;
                                                    "
                                                    class="d-flex align-center"
                                                >
                                                    <b>Type</b>
                                                </v-col>
                                                <v-col cols="9" class="pl-2">
                                                    {{ formatCategory(leasing.type) }}
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                            <v-col v-if="activateTagguing">
                                <FreeTag
                                    :companyTags="allCompanyTags"
                                    :document="inDocument"
                                    :splitUserPartitions="true"
                                    @changed="startToBeDoneIfNecessary"
                                    @onTagsChanged="upsertDocumentTags"
                                />
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                            <v-col class="d-flex align-center col-auto pr-3 title">
                                Informations leasing
                            </v-col>
                            <v-col class="d-flex align-center">
                                <v-divider />
                            </v-col>
                            <v-col cols="12" class="mt-2">
                                <v-form v-model="isValid">
                                    <v-row class="mt-1">
                                        <v-col cols="4">
                                            <v-text-field-filled
                                                v-model="leasing.title"
                                                label="Libellé"
                                                outlined
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                density="compact"
                                            />
                                        </v-col>
                                        <!-- <v-col cols="4" class="pl-1">
                                            <v-select
                                                v-model="leasing.leasingType"
                                                :items="leasingTypes"
                                                label="Type de leasing"
                                                class="oss-"
                                                item-value="value"
                                                item-text="text"
                                                return-object
                                                outlined
                                                density="compact"
                                                hide-details
                                            ></v-select>
                                        </v-col> -->
                                        <v-col cols="4" class="pl-1 mt-2 pt-0">
                                            <v-switch
                                                v-model="leasing.firstPayRentOption"
                                                label="Montant 1er Loyer"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pl-1 mt-2 pt-0">
                                            <v-switch
                                                v-model="leasing.leasingPurchaseOption"
                                                label="Option d'achat"
                                                hide-details
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-1">
                                        <v-col cols="4">
                                            <v-text-field-filled
                                                v-model="leasing.invoiceNumber"
                                                label="Numéro de contrat"
                                                outlined
                                                density="compact"
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                        <v-col class="pl-1" cols="4">
                                            <oss-date-picker-filled
                                                v-model="leasing.startDate"
                                                :label="`Date leasing`"
                                                :textFieldReadOnly="false"
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                hide-details
                                            />
                                        </v-col>
                                        <!-- <v-col class="pl-1" cols="4">
                                            <oss-date-picker-filled
                                                v-model="leasing.bobbeeStartDate"
                                                :label="'Date de reprise'"
                                                :textFieldReadOnly="false"
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                hide-details
                                            ></oss-date-picker-filled>
                                        </v-col> -->
                                        <v-col class="pl-1" cols="4">
                                            <v-text-field-filled
                                                label="Nombre d'échéances"
                                                outlined
                                                density="compact"
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                v-model="leasing.leasingPeriod"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col cols="4">
                                            <v-text-field-filled
                                                v-model.number="leasing.netAmount"
                                                label="Loyer HT"
                                                outlined
                                                density="compact"
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                @change="calculateAmount('netAmount')"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <v-select-filled
                                                v-model.number="leasing.vatRate"
                                                label="Taux TVA ( % )"
                                                :items="vatRates"
                                                item-value="vatRate"
                                                return-object
                                                outlined
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                @update:model-value="calculateAmount('vatRate')"
                                                density="compact"
                                                :item-title="(item) => item.text"
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <v-text-field-filled
                                                v-model.number="leasing.grossAmount"
                                                label="Loyer TTC"
                                                outlined
                                                density="compact"
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                @change="calculateAmount('grossAmount')"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-1">
                                        <v-col cols="4">
                                            <v-text-field-filled
                                                label="Assurances HT"
                                                outlined
                                                density="compact"
                                                hide-details
                                                @change="calculateAmount('insuranceNetAmount')"
                                                v-model="leasing.insuranceNetAmount"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <v-select-filled
                                                v-model.number="leasing.insuranceVatRate"
                                                label="TVA Assurances ( % )"
                                                :items="vatRates"
                                                item-value="vatRate"
                                                return-object
                                                outlined
                                                hide-details
                                                @update:model-value="
                                                    calculateAmount('insuranceVatRate')
                                                "
                                                density="compact"
                                                :item-title="(item) => item.text"
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <v-text-field-filled
                                                label="Assurances TTC"
                                                outlined
                                                density="compact"
                                                hide-details
                                                @change="calculateAmount('insuranceGrossAmount')"
                                                v-model="leasing.insuranceGrossAmount"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                    </v-row>
                                    <!-- <v-divider class="mt-2"></v-divider> -->
                                    <v-row class="mt-1">
                                        <v-col cols="4">
                                            <v-text-field-filled
                                                label="Entretiens HT"
                                                outlined
                                                density="compact"
                                                hide-details
                                                @change="calculateAmount('maintenanceNetAmount')"
                                                v-model="leasing.maintenanceNetAmount"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <v-select-filled
                                                v-model.number="leasing.maintenanceVatRate"
                                                label="TVA Entretiens ( % )"
                                                :items="vatRates"
                                                item-value="vatRate"
                                                return-object
                                                outlined
                                                hide-details
                                                @update:model-value="
                                                    calculateAmount('maintenanceVatRate')
                                                "
                                                density="compact"
                                                :item-title="(item) => item.text"
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <v-text-field-filled
                                                label="Entretiens TTC"
                                                outlined
                                                density="compact"
                                                hide-details
                                                @change="calculateAmount('maintenanceGrossAmount')"
                                                v-model="leasing.maintenanceGrossAmount"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col cols="4">
                                            <v-text-field-filled
                                                label="Frais de dossier"
                                                outlined
                                                density="compact"
                                                hide-details
                                                v-model="leasing.applicationFeeAmount"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <v-text-field-filled
                                                v-if="leasing.firstPayRentOption"
                                                label="Montant 1er loyer TTC"
                                                outlined
                                                density="compact"
                                                hide-details
                                                :readonly="!leasing.firstPayRentOption"
                                                :disabled="!leasing.firstPayRentOption"
                                                v-model="leasing.firstPayRentAmount"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <v-text-field-filled
                                                v-if="leasing.leasingPurchaseOption"
                                                label="Montant résiduel"
                                                outlined
                                                density="compact"
                                                hide-details
                                                :readonly="!leasing.leasingPurchaseOption"
                                                :disabled="!leasing.leasingPurchaseOption"
                                                v-model="leasing.residualAmount"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col cols="12">
                                            <v-text-field-filled
                                                label="Fournisseur"
                                                outlined
                                                hide-details
                                                readonly
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                @click="thirdPartyCompanyDialog = true"
                                                :model-value="leasing.thirdPartyCompany.name"
                                                density="compact"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <!-- <v-divider class="mt-2"></v-divider> -->
                                <v-row class="mt-2">
                                    <v-col cols="12">
                                        <AccountableAccount
                                            v-show="true"
                                            :showLabel="true"
                                            :label="`Compte de mensualités`"
                                            :inputStyle="'padding:0px; margin:0px;'"
                                            :showValidation="false"
                                            :companyId="companyId"
                                            :showDescription="true"
                                            :inAccountableAccountType="'Selected'"
                                            :inAccountableAccount="accountableAccountMonthly"
                                            :inAccountableAccountNames="['612']"
                                            :disabled="false"
                                            :hideDetails="true"
                                            @select-accountableAccount="
                                                selectAccountableAccountMonthly
                                            "
                                            :defineThirdParty="false"
                                            dense
                                        >
                                        </AccountableAccount>
                                    </v-col>
                                    <!-- <v-col cols="6">
                                        <AccountableAccount
                                            v-show="true"
                                            :showLabel="true"
                                            :label="`Compte d'intérêts`"
                                            :inputStyle="'padding:0px; margin:0px;'"
                                            :showValidation="false"
                                            :companyId="companyId"
                                            :showDescription="true"
                                            :inAccountableAccountType="'Selected'"
                                            :inAccountableAccountNames="['661']"
                                            :inAccountableAccount="accountableAccountInterest"
                                            :disabled="false"
                                            :hideDetails="true"
                                            @select-accountableAccount="selectAccountableAccountInterest"
                                            :defineThirdParty="false"
                                            dense

                                        >
                                        </AccountableAccount>
                                    </v-col> -->
                                </v-row>
                                <v-row class="mt-2">
                                    <v-col cols="6" v-if="hasInsuranceAmount">
                                        <AccountableAccount
                                            v-show="true"
                                            :showLabel="true"
                                            :label="`Compte d'assurances`"
                                            :inputStyle="'padding:0px; margin:0px;'"
                                            :showValidation="false"
                                            :companyId="companyId"
                                            :showDescription="true"
                                            :inAccountableAccountType="'Selected'"
                                            :inAccountableAccount="accountableAccountInsurance"
                                            :inAccountableAccountNames="['616']"
                                            :disabled="false"
                                            :hideDetails="true"
                                            @select-accountableAccount="
                                                selectAccountableAccountInsurance
                                            "
                                            :defineThirdParty="false"
                                            dense
                                        >
                                        </AccountableAccount>
                                    </v-col>
                                    <v-col cols="6" v-if="hasMaintenanceAmount">
                                        <AccountableAccount
                                            v-show="true"
                                            :showLabel="true"
                                            :label="`Compte d'entretiens`"
                                            :inputStyle="'padding:0px; margin:0px;'"
                                            :showValidation="false"
                                            :companyId="companyId"
                                            :showDescription="true"
                                            :inAccountableAccountType="'Selected'"
                                            :inAccountableAccountNames="['615']"
                                            :inAccountableAccount="accountableAccountMaintenance"
                                            :disabled="false"
                                            :hideDetails="true"
                                            @select-accountableAccount="
                                                selectAccountableAccountMaintenance
                                            "
                                            :defineThirdParty="false"
                                            dense
                                        >
                                        </AccountableAccount>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2" v-if="document.id">
                            <v-col class="d-flex align-center col-auto pr-3 title">
                                Informations arrêt anticipé
                            </v-col>
                            <v-col class="d-flex align-center">
                                <v-divider />
                            </v-col>
                            <v-col cols="12" class="mt-2">
                                <v-row class="mt-1">
                                    <v-col cols="4" class="pl-2 mt-2 pt-0">
                                        <v-switch
                                            v-model="leasing.leasingEarlyRedemption"
                                            label="Arrêt anticipé"
                                            hide-details
                                        />
                                    </v-col>
                                    <v-col cols="4" class="pl-1">
                                        <v-select-filled
                                            v-model="leasing.leasingEarlyRedemptionDate"
                                            v-if="leasing.leasingEarlyRedemption"
                                            :items="leasingEarlyRedemptionDates"
                                            label="Date d'arrêt anticipé"
                                            item-value="value"
                                            outlined
                                            hide-details
                                            density="compact"
                                            :item-title="(item) => item.text"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="mt-1">
                            <v-col cols="12" class="d-flex justify-center">
                                <v-btn-prev :disabled="previousDisabled()" @click="previous()" />
                                <v-btn-next :disabled="nextDisabled()" @click="next()" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteDocument"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="restoreDialog"
            title="Restaurer le document"
            @valid="
                restoreDocument();
                restoreDialog = false;
            "
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="restoreLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir restaurer le document ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="uploadDocumentDialog"
            title="Importer un document pour ce justificatif"
            max-width="60vw"
            :actions="actions"
        >
            <UploadDocument
                :showFirstPrevious="false"
                :companyId="companyId"
                :documentId="document.id"
                :documentType="'MISCELLANEOUS'"
                :multiple="false"
                :freeTag="false"
                :showBtns="true"
                :actions="actions"
                @fileUploaded="
                    closeUploadDocumentDialog();
                    startToBeDoneIfNecessary();
                "
            />
        </oss-dialog>
        <oss-dialog
            v-model="thirdPartyCompanyDialog"
            title="Choisir un fournisseur"
            max-width="60vw"
        >
            <CompaniesTable
                v-model="leasing.thirdPartyCompany"
                :parentCompanyId="companyId"
                :showGenericCompany="false"
                :showConsumerCompany="false"
                :showCustomerCompanies="false"
                :showSupplierCompanies="true"
                :showExistingCompanies="true"
                :showNewCompanies="true"
                @select-company="selectThirdPartyCompany"
            />
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { calculateLeasing } from "../../../../backend/src/common/leasing/leasingServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import { DocumentBase } from "./DocumentBase";
import ossPdf from "./DocumentPDF.vue";
import DocumentWizardDialog from "./DocumentWizardDialog.vue";
import { DocumentMenu } from "./DocumentMenu.vue";
import Chat from "../chat/Chat.vue";
import FreeTag from "../tag/FreeTag.vue";
import Sepa from "../pay/Sepa.vue";
import AccountingItemStatic from "../AccountingItemStatic.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import UPSERT_RECURRENT_DOCUMENT from "../../graphql/recurrentDocument/RecurrentDocuments.gql";
import _ from "lodash";
import AccountableAccount from "../AccountableAccount.vue";
import BankAccountSelector from "../bank/BankAccountSelector.vue";
import moment from "moment-timezone";
import UploadDocument from "./UploadDocuments.vue";
import CompaniesTable from "../admin/CompaniesTable.vue";
import getEnv from "../../env";
import { Component, Vue, toNative, Ref } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { DialogAction } from "@/services/dialogAction";
import { isInsideAccountingClosing } from "../../services/accountingPeriods";
import { mathFix } from "../../services/mathServices";

import {
    MenuDisplayDisplayModeOptions,
    MenuDisplayDotMenuOptions,
    MenuDisplayOptions,
    MenuDisplayZoomOptions,
    MenuDisplayRotationOptions,
} from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";

const env = getEnv();

@Component({
    components: {
        DocumentWizardDialog,
        Chat,
        ossPdf,
        FreeTag,
        Sepa,
        AccountingItemStatic,
        UsersActivitiesHistory,
        AccountableAccount,
        BankAccountSelector,
        UploadDocument,
        CompaniesTable,
        DocumentMenu,
    },
    emits: ["leasing-upserted", "onEdit"],
})
export class DocumentLeasing extends DocumentBase {
    @Ref("ossPdfRef") ossPdf: any;

    localEnv = env.environnement;

    items: Array<any> = [];

    loading = false;

    activeUploadDocument = false;

    showAccountingLines: boolean = false;

    restoreDialog = false;

    bankAccountDialog = false;

    uploadDocumentDialog = false;

    thirdPartyCompanyDialog = false;

    isValid = false;

    windowStep = "table";

    accountableAccountMonthly = null;
    // accountableAccountInterest = null
    accountableAccountInsurance = null;
    accountableAccountMaintenance = null;

    defaultLeasing = {
        title: "",
        startDate: "",
        type: "LEASING",
        status: "ANALYSED",
        invoiceNumber: "",
        bobbeeStartDate: "",
        leasingType: {
            value: "",
            text: "",
        },
        leasingPeriod: null,
        netAmount: null,
        grossAmount: null,
        vatAmount: null,
        vatRate: {
            value: "0",
            vatType: null,
            vatRate: 0,
            text: "Pas de TVA",
        },
        leasingRate: null,
        leasingPurchaseOption: false,
        leasingEarlyRedemption: false,
        leasingEarlyRedemptionAmount: null,
        leasingEarlyRedemptionDate: "",
        applicationFeeAmount: null,
        insuranceNetAmount: null,
        insuranceVatAmount: null,
        insuranceGrossAmount: null,
        insuranceVatRate: {
            value: "0",
            vatType: null,
            vatRate: 0,
            text: "Pas de TVA",
        },
        maintenanceNetAmount: null,
        maintenanceVatAmount: null,
        maintenanceGrossAmount: null,
        maintenanceVatRate: {
            value: "0",
            vatType: null,
            vatRate: 0,
            text: "Pas de TVA",
        },
        // monthlyLeasingRate: null,
        residualAmount: null,
        firstPayRentAmount: null,
        residualRate: null,
        aaMonthlyName: "",
        aaInterestName: "",
        aaInsuranceName: "",
        aaMaintenanceName: "",
        thirdPartyCompany: {
            id: "",
            name: "",
        },
        totalAmount: null,
        firstPayRentOption: false,
        residualValue: 0,
        tags: [],
    };

    leasing = _.cloneDeep(this.defaultLeasing);

    documentType_ = "";

    actions = {
        action: new DialogAction(),
    };

    get documentMenuZoomOptions(): MenuDisplayZoomOptions {
        const zoomOptions: MenuDisplayZoomOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.zoomButtons,
        };

        zoomOptions.isDisplay =
            (!this.isPDF && this.zoomManager && this.windowStep === "display-pdf") ||
            (this.isPDF && this.windowStep === "display-pdf");
        zoomOptions.isResetZoomDisabled = this.isPDF ? false : this.zoomManager.disableResetZoom();
        zoomOptions.isZoomInDisabled = this.isPDF ? false : this.zoomManager.disableZoomIn();
        zoomOptions.isZoomOutDisabled = this.isPDF ? false : this.zoomManager.disableZoomOut();

        return zoomOptions;
    }

    get documentMenuDisplayModeOptions(): MenuDisplayDisplayModeOptions {
        const displayModeOptions: MenuDisplayDisplayModeOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.displayModeButtons,
        };

        displayModeOptions.isDisplay = true;
        displayModeOptions.isAccountingLineModeDisplay = this.document.accountingLines?.length;
        displayModeOptions.isPDFModeDisplay = true;
        displayModeOptions.isTableModeDisplay = true;
        displayModeOptions.isPDFModeDisabled = !this.document.signedUrl;

        return displayModeOptions;
    }
    get documentMenuOptionsRotateDocumentButton(): MenuDisplayRotationOptions {
        let rotationButton: MenuDisplayRotationOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.RotateDocument,
        };
        rotationButton.isDisplay =
            (!this.isPDF && this.windowStep === "display-pdf") ||
            (this.isPDF && this.windowStep === "display-pdf");

        return rotationButton;
    }

    get documentMenuDotMenuOptions(): MenuDisplayDotMenuOptions {
        const dotMenuOptions: MenuDisplayDotMenuOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.dotMenu,
        };

        dotMenuOptions.isDisplay = true;

        dotMenuOptions.document.isDisplay = !!this.document.signedUrl;
        dotMenuOptions.document.title = "Télécharger le document";

        dotMenuOptions.upload.isDisplay = !this.document.signedUrl;
        dotMenuOptions.upload.title = "Ajouter un document";

        dotMenuOptions.activity.isDisplay = this.isAccountingUser;
        dotMenuOptions.activity.title = "Afficher l'activité";
        dotMenuOptions.activity.disabled = !this.document.signedUrl;

        dotMenuOptions.delete.isDisplay = true;
        dotMenuOptions.delete.title = "Supprimer";
        dotMenuOptions.delete.disabled = this.disabledDelete;

        return dotMenuOptions;
    }

    get documentMenuOptions(): MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = {
            ...documentMenuDisplayOptionsDefaultScheme,
        };

        documentMenuOption.zoomButtons = this.documentMenuZoomOptions;
        documentMenuOption.RotateDocument = this.documentMenuOptionsRotateDocumentButton;
        documentMenuOption.displayModeButtons = this.documentMenuDisplayModeOptions;
        documentMenuOption.dotMenu = this.documentMenuDotMenuOptions;

        return documentMenuOption;
    }

    /**
     * Zooms in the PDF by increasing its zoom level.
     */
    public zoomInPdf(): void {
        if (this.ossPdf) {
            this.ossPdf.zoomIn();
        }
    }

    /**
     * Resets the zoom level of the PDF to its default state.
     */
    public resetZoomPdf(): void {
        if (this.ossPdf) {
            this.ossPdf.resetZoom();
        }
    }

    /**
     * Zooms out the PDF by decreasing its zoom level.
     */
    public zoomOutPdf(): void {
        if (this.ossPdf) {
            this.ossPdf.zoomOut();
        }
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    @Watch("document", { deep: true })
    initialize() {
        if (this.document) {
            if (this.document?.data?.recurrentDocument) {
                this.leasing = JSON.parse(JSON.stringify(this.document.data.recurrentDocument));
            } else {
                this.leasing = _.cloneDeep(this.defaultLeasing);
            }
        } else {
            this.leasing = _.cloneDeep(this.defaultLeasing);
        }

        if (this.leasing.aaMonthlyName) {
            this.accountableAccountMonthly = {
                name: this.leasing.aaMonthlyName,
            };
        }

        // if (this.leasing.aaInterestName) {
        //     this.accountableAccountInterest = {
        //         name: this.leasing.aaInterestName
        //     }
        // }

        if (this.leasing.aaInsuranceName) {
            this.accountableAccountInsurance = {
                name: this.leasing.aaInsuranceName,
            };
        }

        if (this.leasing.aaMaintenanceName) {
            this.accountableAccountMaintenance = {
                name: this.leasing.aaMaintenanceName,
            };
        }
    }

    get documentType() {
        if (this.documentType_) {
            return this.documentType_;
        }
        return this.document.type;
    }

    set documentType(data) {
        this.documentType_ = data;
    }

    get reUploadDocument() {
        if (!this.document) return false;
        if (this.currentUser.profile.configuration.document.write) {
            return true;
        }
        return false;
    }

    get headers() {
        const headers = [
            { title: "Date", value: "date" },
            { title: "Loyer HT", value: "netAmount" },
            { title: "TVA", value: "vatAmount" },
            { title: "Loyer TTC", value: "grossAmount" },
        ];
        if (this.hasInsuranceAmount) {
            headers.push(
                { title: "Assurances", value: "insuranceNetAmount" },
                { title: "TVA Assurances", value: "insuranceVatAmount" },
            );
        }
        if (this.hasMaintenanceAmount) {
            headers.push(
                { title: "Entretiens", value: "maintenanceNetAmount" },
                { title: "TVA Entretiens", value: "maintenanceVatAmount" },
            );
        }

        headers.push({ title: "Total", value: "totalAmount" });

        return headers;
    }

    get vatRates() {
        const vats = [
            { value: "0", vatType: null, vatRate: 0, text: "Pas de TVA" },
            { value: "20", vatType: null, vatRate: 20, text: "20 %" },
            { value: "10", vatType: null, vatRate: 10, text: "10 %" },
            { value: "8.5", vatType: null, vatRate: 8.5, text: "8.5 %" },
            { value: "5.5", vatType: null, vatRate: 5.5, text: "5.5 %" },
            { value: "2.1", vatType: null, vatRate: 2.1, text: "2.1 %" },
        ];

        return vats;
    }

    get leasingTypes() {
        const leasingTypes = [
            // { value: "OPERATIONAL", text: "Opérationnel" },
            { value: "FINANCIAL", text: "Financier" },
        ];
        return leasingTypes;
    }

    get hasMaintenanceAmount() {
        if (this.leasing.maintenanceNetAmount) {
            return true;
        }
        return false;
    }

    get hasInsuranceAmount() {
        if (this.leasing.insuranceNetAmount) {
            return true;
        }
        return false;
    }

    get monthlyAccountableAccounts() {
        const monthlyAccountableAccounts: string[] = ["164000"];

        return monthlyAccountableAccounts;
    }

    get allAvailableCompanies() {
        return this.$store.state.user.allAvailableCompanies;
    }

    get calculatedLeasing() {
        if (
            !this.leasing?.netAmount ||
            !this.leasing?.grossAmount ||
            !this.leasing?.leasingPeriod
        ) {
            return [];
        } else {
            let calculatedLeasing = [];

            if (
                this.leasing.netAmount &&
                this.leasing.grossAmount &&
                this.leasing.startDate &&
                this.leasing.leasingPeriod
            ) {
                calculatedLeasing = calculateLeasing(this.leasing as any);
            }

            if (calculatedLeasing.length) {
                calculatedLeasing.forEach((payment) => {
                    payment.netAmount = mathFix(payment.netAmount, 2);
                    payment.grossAmount = mathFix(payment.grossAmount, 2);
                    payment.vatAmount = mathFix(payment.vatAmount, 2);
                    if (payment.insuranceNetAmount) {
                        payment.insuranceNetAmount = mathFix(payment.insuranceNetAmount, 2);
                    }
                    if (payment.insuranceGrossAmount) {
                        payment.insuranceGrossAmount = mathFix(payment.insuranceGrossAmount, 2);
                    }
                    if (payment.insuranceVatAmount) {
                        payment.insuranceVatAmount = mathFix(payment.insuranceVatAmount, 2);
                    }
                    if (payment.maintenanceNetAmount) {
                        payment.maintenanceNetAmount = mathFix(payment.maintenanceNetAmount, 2);
                    }
                    if (payment.maintenanceGrossAmount) {
                        payment.maintenanceGrossAmount = mathFix(payment.maintenanceGrossAmount, 2);
                    }
                    if (payment.maintenanceVatAmount) {
                        payment.maintenanceVatAmount = mathFix(payment.maintenanceVatAmount, 2);
                    }
                    payment.totalAmount = mathFix(
                        parseFloat(payment.grossAmount) +
                            parseFloat(payment.insuranceGrossAmount) +
                            parseFloat(payment.maintenanceGrossAmount),
                        2,
                    );
                });
            }

            return calculatedLeasing;
        }
    }

    get leasingEarlyRedemptionDates() {
        const leasingEarlyRedemptionDates = [];

        if (this.calculatedLeasing) {
            this.calculatedLeasing.forEach((payment) => {
                leasingEarlyRedemptionDates.push({
                    value: payment.date,
                    text: this.formatDate(payment.date),
                });
            });
        }
        return leasingEarlyRedemptionDates;
    }

    get isInsideAccountingClosing() {
        if (this.leasing && this.leasing?.startDate) {
            if (this.leasing?.startDate) {
                return isInsideAccountingClosing(this.$store, this.leasing.startDate);
            }
        }

        return false;
    }

    // calculateMonthlyLeasingRate() {
    //     if (this.leasing?.leasingRate) {
    //         this.leasing.monthlyLeasingRate = (this.leasing.leasingRate / 12).toFixed(4)
    //     } else {
    //         this.leasing.monthlyLeasingRate = 0
    //     }
    // }

    calculateAmount(changedField) {
        switch (changedField) {
            case "netAmount":
                if (this.leasing.netAmount && this.leasing.vatRate.vatRate) {
                    this.leasing.grossAmount = (
                        this.leasing.netAmount *
                        (1 + this.leasing.vatRate.vatRate / 100)
                    ).toFixed(2);
                } else {
                    this.leasing.grossAmount = this.leasing.netAmount;
                }
                break;
            case "grossAmount":
                if (this.leasing.grossAmount && this.leasing.vatRate.vatRate) {
                    this.leasing.netAmount = (
                        this.leasing.grossAmount /
                        (1 + this.leasing.vatRate.vatRate / 100)
                    ).toFixed(2);
                } else {
                    this.leasing.netAmount = this.leasing.grossAmount;
                }
                break;
            case "vatRate":
                if (this.leasing.netAmount && this.leasing.vatRate.vatRate) {
                    this.leasing.grossAmount = (
                        this.leasing.netAmount *
                        (1 + this.leasing.vatRate.vatRate / 100)
                    ).toFixed(2);
                } else {
                    this.leasing.grossAmount = this.leasing.netAmount;
                }
                break;
            case "insuranceNetAmount":
                if (this.leasing.insuranceNetAmount && this.leasing.insuranceVatRate.vatRate) {
                    this.leasing.insuranceGrossAmount = (
                        this.leasing.insuranceNetAmount *
                        (1 + this.leasing.insuranceVatRate.vatRate / 100)
                    ).toFixed(2);
                } else {
                    this.leasing.insuranceGrossAmount = this.leasing.insuranceNetAmount;
                }
                break;
            case "insuranceGrossAmount":
                if (this.leasing.insuranceGrossAmount && this.leasing.insuranceVatRate.vatRate) {
                    this.leasing.insuranceNetAmount = (
                        this.leasing.insuranceGrossAmount /
                        (1 + this.leasing.insuranceVatRate.vatRate / 100)
                    ).toFixed(2);
                } else {
                    this.leasing.insuranceNetAmount = this.leasing.insuranceGrossAmount;
                }
                break;
            case "insuranceVatRate":
                if (this.leasing.insuranceNetAmount && this.leasing.insuranceVatRate.vatRate) {
                    this.leasing.insuranceGrossAmount = (
                        this.leasing.insuranceNetAmount *
                        (1 + this.leasing.insuranceVatRate.vatRate / 100)
                    ).toFixed(2);
                } else {
                    this.leasing.insuranceGrossAmount = this.leasing.insuranceNetAmount;
                }
                break;
            case "maintenanceNetAmount":
                if (this.leasing.maintenanceNetAmount && this.leasing.maintenanceVatRate.vatRate) {
                    this.leasing.maintenanceGrossAmount = (
                        this.leasing.maintenanceNetAmount *
                        (1 + this.leasing.maintenanceVatRate.vatRate / 100)
                    ).toFixed(2);
                } else {
                    this.leasing.maintenanceGrossAmount = this.leasing.maintenanceNetAmount;
                }
                break;
            case "maintenanceGrossAmount":
                if (
                    this.leasing.maintenanceGrossAmount &&
                    this.leasing.maintenanceVatRate.vatRate
                ) {
                    this.leasing.maintenanceNetAmount = (
                        this.leasing.maintenanceGrossAmount /
                        (1 + this.leasing.maintenanceVatRate.vatRate / 100)
                    ).toFixed(2);
                } else {
                    this.leasing.maintenanceNetAmount = this.leasing.maintenanceGrossAmount;
                }
                break;
            case "maintenanceVatRate":
                if (this.leasing.maintenanceNetAmount && this.leasing.maintenanceVatRate.vatRate) {
                    this.leasing.maintenanceGrossAmount = (
                        this.leasing.maintenanceNetAmount *
                        (1 + this.leasing.maintenanceVatRate.vatRate / 100)
                    ).toFixed(2);
                } else {
                    this.leasing.maintenanceGrossAmount = this.leasing.maintenanceNetAmount;
                    // this.leasing.netAmount += this.leasing.maintenanceNetAmount
                    // this.leasing.grossAmount += this.leasing.maintenanceGrossAmount
                }
                break;
        }
    }

    @Watch("leasing.leasingPurchaseOption")
    resetResidual() {
        if (!this.leasing.leasingPurchaseOption) {
            this.leasing.residualRate = 0;
            this.leasing.residualValue = 0;
            this.leasing.residualAmount = 0;
        }
    }

    selectAccountableAccountMonthly(data) {
        this.accountableAccountMonthly = data.accountableAccount;

        if (data && data.accountableAccount && data.accountableAccount.name) {
            this.leasing.aaMonthlyName = data.accountableAccount.name;
        } else {
            this.leasing.aaMonthlyName = "";
        }
    }

    // selectAccountableAccountInterest(data) {
    //     this.accountableAccountInterest = data.accountableAccount

    //     if (data && data.accountableAccount && data.accountableAccount.name) {
    //         this.leasing.aaInterestName = data.accountableAccount.name
    //     } else {
    //         this.leasing.aaInterestName = ""
    //     }
    // }

    selectAccountableAccountInsurance(data) {
        this.accountableAccountInsurance = data.accountableAccount;

        if (this.accountableAccountInsurance && this.accountableAccountInsurance.name) {
            this.leasing.aaInsuranceName = this.accountableAccountInsurance.name;
        } else {
            this.leasing.aaInsuranceName = "";
        }
    }

    selectAccountableAccountMaintenance(data) {
        this.accountableAccountMaintenance = data.accountableAccount;

        if (data && data.accountableAccount && data.accountableAccount.name) {
            this.leasing.aaMaintenanceName = data.accountableAccount.name;
        } else {
            this.leasing.aaMaintenanceName = "";
        }
    }

    selectThirdPartyCompany(data) {
        if (data && data.id) {
            this.leasing.thirdPartyCompany = data;
        } else {
            this.leasing.thirdPartyCompany = null;
        }

        this.thirdPartyCompanyDialog = false;
    }

    async valid() {
        await this.upsertLeasing();
    }

    async upsertLeasing() {
        const upsertedLeasing = await this.$apollo.mutate({
            mutation: UPSERT_RECURRENT_DOCUMENT,
            variables: {
                id: this.document?.id || "",
                companyId: this.companyId,
                recurrentDocument: this.leasing,
            },
        });

        if (upsertedLeasing.data.upsertRecurrentDocument) {
            this.$router.go(-1);
            this.$emit("leasing-upserted", upsertedLeasing.data.upsertRecurrentDocument);
        }
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    @Watch("documentId")
    onDocumentChanged(prev, next) {
        if (prev !== next) {
            this.clearVariantList();
            this.document = this.inDocument;

            if (this.document.signedUrl && !this.isPDF) {
                this.zoomManager.instanciateSvgZoom(this.svgSuffix);
            }
            if (!this.document?.signedUrl && this.isAccountingUser) {
                this.showAccountingLines = true;
            }
        }
    }

    beforeMount() {
        if (this.inDocument) {
            this.svgSuffix = "document-miscellaneous";
            //
            this.onDocumentChanged(this.inDocument.id, undefined);
            if (!this.document.displayName) {
                this.document.displayName = this.document.name;
            }
            this.finishMounted();
        }

        this.initialize();
        // this.calculateMonthlyLeasingRate();
    }

    closeUploadDocumentDialog() {
        this.uploadDocumentDialog = false;
        this.$emit("onEdit");
    }

    @Watch("document.tags", { deep: true })
    onDocumentLoaded() {
        debugger;
        if (this.document?.tags?.length) {
            const existingTagIds = new Set(this.leasing.tags.map((tag) => tag.id));

            this.document.tags.forEach((tag) => {
                if (!existingTagIds.has(tag.id)) {
                    this.leasing.tags.push(tag);
                    existingTagIds.add(tag.id);
                }
            });
        }
    }

    upsertDocumentTags(tags) {
        debugger;
        if (tags.tags.length) {
            const existingTagIds = new Set(this.leasing.tags.map((tag) => tag.id));

            tags.tags.forEach((tag) => {
                if (!existingTagIds.has(tag.id)) {
                    this.leasing.tags.push(tag);
                    existingTagIds.add(tag.id);
                }
            });
        }
    }
}

export default toNative(DocumentLeasing);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
